import { Icon, Button, Card, CardBody } from '@repo/ui';

interface ErrorCardProps {
  title: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorCard({ title, message, onRetry }: ErrorCardProps) {
  return (
    <Card variant="outlined" padding="lg">
      <CardBody>
        <div className="text-center py-8">
          <h3 className="text-lg font-medium text-red-600 dark:text-red-400 mb-2">{title}</h3>
          <p className="text-xtnd-dark-600 dark:text-xtnd-dark-400 mb-4">{message}</p>
          {onRetry && (
            <Button
              variant="primary"
              onClick={onRetry}
              leftIcon={<Icon name="HiRefresh" size="sm" />}
            >
              Retry
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
}

